import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import { loadReceipts, deleteReceipt } from '../../../../../../redux/actions/receipt.actions';

const ReceiptRow = props => {
    return (
        <tr onClick={() => props.editRow(props.receipt)}>
            <td>{moment(props.receipt.created_at).format('ddd, MMM Do, YYYY')}</td>
            <td>{props.receipt.recipient_guardian_full_name}</td>
            <td>${props.receipt.amount_requested}</td>
            <td>${props.receipt.amount_received}</td>
            <td onClick={e => e.stopPropagation()}>
                <Viewer src={props.receipt.image || props.receipt.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
            </td>
            <td className="action-row">
                <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => props.deleteRow({ receipt: props.receipt, event })}>Delete</div>
            </td>
        </tr>
    );
};

class Receipts extends Component {
    async componentDidMount() {
        const { clientId, progressId } = this.props.match.params;
        await this.props.loadReceipts({ recipientId: clientId, progressId });
    }
    openReceiptsModal = () => {
        const event = new CustomEvent('open-receipt-modal', {
            detail: {
                ...this.props.match.params,
                recipientId: this.props.match.params.clientId
            }
        });
        window.dispatchEvent(event);
    }
    editRow = (receipt) => {
        const { clientId, progressId } = this.props.match.params;
        const event = new CustomEvent('open-receipt-modal', {
            detail: {
                ...receipt,
                recipientId: clientId,
                progressId
            }
        });
        window.dispatchEvent(event);
    }
    deleteRow = ({ event, receipt }) => {
        event.preventDefault();
        event.stopPropagation();
        const { clientId, progressId } = this.props.match.params;
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this receipt?`,
                onDelete: () => {
                    this.props.deleteReceipt({ recipientId: clientId, progressId, receiptId: receipt.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { receipts } = this.props;
        return (
            <div className="panel-receipts panel-content">
                { this.props.allLoading ?
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    receipts.length ?
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Guardian Name</th>
                                    <th>Amount Requested</th>
                                    <th>Amount Received</th>
                                    <th>Preview</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                { receipts.map((receipt, i) => (
                                    <ReceiptRow key={i}
                                        receipt={receipt}
                                        editRow={this.editRow}
                                        deleteRow={this.deleteRow} />
                                ))}
                            </tbody>
                        </table> :
                        <div className="intro">
                            <div className="intro-text">
                                No receipts. Start by <span className="link" onClick={this.openReceiptsModal} >adding one</span>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    receipts: state.receipt.receipts,
    receiptsById: state.receipt.receiptsById,
    allLoading: state.receipt.allLoading
});

const mapDispatchToProps = {
    loadReceipts,
    deleteReceipt
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Receipts));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/progress-panels/Receipts.jsx